var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M24.929 2.929A10 10 0 1 1 39.07 17.07 10 10 0 0 1 24.93 2.93ZM32 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M20.686 24.686A16 16 0 0 1 48 36v6a2 2 0 0 1-2 2h-4.19l-1.82 18.199A2 2 0 0 1 38 64H26a2 2 0 0 1-1.99-1.801L22.19 44H18a2 2 0 0 1-2-2v-6a16 16 0 0 1 4.686-11.314ZM32 24a12 12 0 0 0-12 12v4h4a2 2 0 0 1 1.99 1.801L27.81 60h8.38l1.82-18.199A2 2 0 0 1 40 40h4v-4a12 12 0 0 0-12-12Z"
})));
export { SvgUser as ReactComponent };
export default __webpack_public_path__ + "static/media/f6b5b5de.svg";